<template>
    <div class="page-wrap">
        <header class="page-top centered">
            <router-link to="/" class="logo" aria-label="WizzoStream"></router-link>
            <router-link to="/" class="back"><span class="fas fa-arrow-right"></span> חזרה לדף הבית</router-link>
        </header>

        <article class="centered page-card">
            <div v-if="item">
                <h1>{{ item.title }}</h1>
                <div class="page-text" v-html="item.text"></div>
            </div>
            <p v-else-if="failed" class="page-state">העמוד לא נטען כרגע. אפשר לפנות אלינו ב-<a href="mailto:support@wizzo.stream">support@wizzo.stream</a></p>
            <p v-else class="page-state">טוען...</p>
        </article>
    </div>
</template>

<script>

// WizzoStream's own terms (CRM_pages 66); page 65 is kvod's, its landing reads that one (chat #3872)
const TERMS_PAGE_ID = 66;

export default {
    data(){
        return {
            item: false,
            failed: false,
        }
    },
    mounted() {

        this.api({ action: 'get_page', data: {id: TERMS_PAGE_ID}}, (data) => {
            if (data && data.data && data.data.text) {
                this.item = data.data;
                document.title = data.data.title + ' | WizzoStream';
            }
            else this.failed = true;
        }, () => { this.failed = true; });

    },
}

</script>

<style lang="scss" scoped>
.page-wrap { min-height: 70vh; padding-block: 32px 80px; padding-inline: var(--gap); color: var(--text-light); }

.page-top { max-width: 860px; display: flex; align-items: center; justify-content: space-between; margin-block-end: 40px;
    .logo { display: block; }
    .back { display: inline-flex; align-items: center; gap: 8px; color: var(--text-muted); font-size: var(--h6);
        &:hover, &:focus-visible { color: var(--color1); }
    }
}

.page-card { max-width: 860px; background: var(--navy-mid); border: 1px solid rgba(255, 255, 255, 0.06); border-radius: var(--radius_b); padding: var(--padding_b);

    h1 { font-size: var(--h2); font-weight: 700; color: #fff; margin-block-end: 28px; }
}

.page-text { font-size: var(--h5); line-height: 1.7; color: var(--text-light);
    :deep(p) { margin-block-end: 14px; }
    :deep(strong) { display: inline-block; color: #fff; font-size: var(--h4); margin-block-start: 14px; }
    :deep(a) { color: var(--color1);
        &:hover { text-decoration: underline; }
    }
}

.page-state { color: var(--text-muted);
    a { color: var(--color1); }
}
</style>
